// Parameters used in a URL to configure a external source landing page
export enum ExtSourceParamKeys {
  externalId = 'externalId',
  language = 'lng',
  product = 'p',
  referrer = 'referrer',
  sourceId = 'sourceId',
}

// Product to dynamically create the landing page for
export enum ExtSourceProduct {
  car = 'car',
  carAndHome = 'carHome',
  condo = 'condo',
  home = 'home',
  tenant = 'tenant',
}

// Parameters used in a URL to become a magic link
export enum MagicLinkParamKeys {
  applicationId = 'a',
  language = 'lng',
  token = 't',
}

// Parameters used in a URL to allow GA tracking - using Goolge naming convention
export enum UtmParamKeys {
  source = 'utm_source',
  medium = 'utm_medium',
  campaign = 'utm_campaign',
}

export enum UtmSourceValues {
  youset = 'youset',
  clicAssure = 'clicAssure',
}

export enum UtmMediumValues {
  broker = 'broker',
  email = 'email',
  partners = 'partners',
  referralProgram = 'referralProgram',
  sms = 'sms',
}

export enum UtmCampaignValues {
  autopilot = 'autopilot',
  coverage = 'coverage',
  checkout = 'checkout',
  policyIssued = 'policyIssued',
  referralBonusRefereeEmail = 'referralBonusRefereeEmail',
  referralBonusReferrerEmail = 'referralBonusReferrerEmail',
}
